import React from 'react';

export const NumPad = (props) => (
  <svg
    fill="none"
    height="31"
    viewBox="0 0 31 31"
    width="31"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.3486 19.2675C17.5243 19.2675 19.288 17.5037 19.288 15.3281C19.288 13.1524 17.5243 11.3887 15.3486 11.3887C13.1729 11.3887 11.4092 13.1524 11.4092 15.3281C11.4092 17.5037 13.1729 19.2675 15.3486 19.2675Z"
      fill="#8D959C"
    />
    <path
      d="M26.3793 19.2675C28.555 19.2675 30.3188 17.5037 30.3188 15.3281C30.3188 13.1524 28.555 11.3887 26.3793 11.3887C24.2037 11.3887 22.4399 13.1524 22.4399 15.3281C22.4399 17.5037 24.2037 19.2675 26.3793 19.2675Z"
      fill="#8D959C"
    />
    <path
      d="M4.31831 19.2675C6.49398 19.2675 8.25772 17.5037 8.25772 15.3281C8.25772 13.1524 6.49398 11.3887 4.31831 11.3887C2.14264 11.3887 0.378906 13.1524 0.378906 15.3281C0.378906 17.5037 2.14264 19.2675 4.31831 19.2675Z"
      fill="#8D959C"
    />
    <path
      d="M15.3486 8.23623C17.5243 8.23623 19.288 6.4725 19.288 4.29683C19.288 2.12115 17.5243 0.357422 15.3486 0.357422C13.1729 0.357422 11.4092 2.12115 11.4092 4.29683C11.4092 6.4725 13.1729 8.23623 15.3486 8.23623Z"
      fill="#8D959C"
    />
    <path
      d="M26.3793 8.23623C28.555 8.23623 30.3188 6.4725 30.3188 4.29683C30.3188 2.12115 28.555 0.357422 26.3793 0.357422C24.2037 0.357422 22.4399 2.12115 22.4399 4.29683C22.4399 6.4725 24.2037 8.23623 26.3793 8.23623Z"
      fill="#8D959C"
    />
    <path
      d="M4.3188 8.23623C6.49447 8.23623 8.2582 6.4725 8.2582 4.29683C8.2582 2.12115 6.49447 0.357422 4.3188 0.357422C2.14313 0.357422 0.379395 2.12115 0.379395 4.29683C0.379395 6.4725 2.14313 8.23623 4.3188 8.23623Z"
      fill="#8D959C"
    />
    <path
      d="M15.3486 30.2968C17.5243 30.2968 19.288 28.533 19.288 26.3574C19.288 24.1817 17.5243 22.418 15.3486 22.418C13.1729 22.418 11.4092 24.1817 11.4092 26.3574C11.4092 28.533 13.1729 30.2968 15.3486 30.2968Z"
      fill="#8D959C"
    />
    <path
      d="M26.3793 30.2968C28.555 30.2968 30.3188 28.533 30.3188 26.3574C30.3188 24.1817 28.555 22.418 26.3793 22.418C24.2037 22.418 22.4399 24.1817 22.4399 26.3574C22.4399 28.533 24.2037 30.2968 26.3793 30.2968Z"
      fill="#8D959C"
    />
    <path
      d="M4.31831 30.2968C6.49398 30.2968 8.25772 28.533 8.25772 26.3574C8.25772 24.1817 6.49398 22.418 4.31831 22.418C2.14264 22.418 0.378906 24.1817 0.378906 26.3574C0.378906 28.533 2.14264 30.2968 4.31831 30.2968Z"
      fill="#8D959C"
    />
  </svg>
);
